import { reloadData } from '@axo/form/data-access/backend-sync';
import { ESkatLogin } from '@axo/shared/auth/providers';
import { ReactNode, useMemo } from 'react';
import { useAxoFormContext } from '../../../context/AxoForm/AxoForm';
import type { DenmarkFormData } from '../LoanApplication/FormData.dk.types';
import { useESkat } from './hooks/useESkat';

type ESkatLoginButtonProps = {
  children: ReactNode;
  hasIcon?: boolean;
};
export const ESkatLoginButton = ({
  children,
  hasIcon,
}: ESkatLoginButtonProps) => {
  const { baseUrl } = useAxoFormContext<DenmarkFormData>();

  const { applicationId, customerJWT } = useMemo(() => reloadData.get(), []);

  const { onESkatError, onESkatSuccess } = useESkat();

  return (
    <ESkatLogin
      applicationID={applicationId}
      token={customerJWT}
      axoApiUrl={baseUrl}
      onError={onESkatError}
      onSuccess={onESkatSuccess}
      hasIcon={hasIcon}
    >
      {children}
    </ESkatLogin>
  );
};
